import { t } from "i18next";
import { ComputeFieldComponent } from "../computeFields";
import { ArtworkInBibliography } from "../types";
import { SeparatedList } from "./shared/utils";
import { ComponentProps } from "react";

export const BibliographyDescriptionCF: ComputeFieldComponent<
  Pick<
    ArtworkInBibliography,
    | "bibliography"
    | "oeuvresDansBibliographieDescriptionCitePage"
    | "oeuvresDansBibliographieDescriptionReproduitPage"
    | "oeuvresDansBibliographieDescriptionReproductionCouleur"
    | "oeuvresDansBibliographieDescriptionNonPagine"
  >
> = ({ input, language, ...props }) => {
  return (
    <>
      <SeparatedList
        {...props}
        lineBreak={false}
        language={language}
        commaSeparated
        input={[
          <span
            dangerouslySetInnerHTML={{
              __html: input.bibliography?.bibliographieDescriptionResumeLong,
            }}
          />,
          input.oeuvresDansBibliographieDescriptionCitePage && (
            <>
              {t("computeField.citePageAbbrege")}{" "}
              {input.oeuvresDansBibliographieDescriptionCitePage}
            </>
          ),
          <SeparatedList
            {...props}
            language={language}
            commaSeparated={false}
            lineBreak={false}
            input={[
              input.oeuvresDansBibliographieDescriptionReproductionCouleur &&
                t("computeField.reproduitCouleurAbbrege"),
              input.oeuvresDansBibliographieDescriptionReproduitPage &&
                !input.oeuvresDansBibliographieDescriptionReproductionCouleur &&
                t("computeField.reproduitPageAbbrege"),
              input.oeuvresDansBibliographieDescriptionReproduitPage,
            ]}
          />,
          input.oeuvresDansBibliographieDescriptionNonPagine && (
            <>{t("computeField.nonPagineAbbrege")}</>
          ),
        ]}
      />
    </>
  );
};

export const RelatedBibliographiesCF: ComputeFieldComponent<{
  relatedBibliographies?: ComponentProps<
    typeof BibliographyDescriptionCF
  >["input"][];
}> = ({ input, lineBreak = true, ...props }) => {
  if (
    !input.relatedBibliographies ||
    input.relatedBibliographies.length === 0
  ) {
    return <></>;
  }
  return (
    <SeparatedList
      {...props}
      input={input.relatedBibliographies.map((bibliography, index) => (
        <BibliographyDescriptionCF
          key={index}
          input={bibliography}
          {...props}
        />
      ))}
      lineBreak={lineBreak}
    />
  );
};
